module.exports = __webpack_public_path__ + "img/9791130607375.34dc5503.jpg";